import React from 'react';
import { Container, Icon, Line, Subtitle, TextContainer, Title, Wrapper } from './styles';

interface ICardHistory {
  title: string;
  subtitle: string;
  lined?: boolean;
}

export const CardHistory: React.FC<ICardHistory> = ({ title, subtitle, children, lined }) => {
  return (
    <Wrapper>
      {lined && <Line />}
      <Container>
        <Icon>{children}</Icon>
        <TextContainer>
          <Title>{title}</Title>
          <Subtitle>{subtitle}</Subtitle>
        </TextContainer>
      </Container>
    </Wrapper>
  );
};
